/**
 * Open Modal javascript trigger
 */
function openModal(modal, opener){
  if(modal && typeof modal.show === 'function') {
    try {
      modal.show(opener);
    } catch (err) {
      console.error('Modal open error:', err);
    }
  }
}

/**
* background Overlay
*/
class SiteOverlay extends HTMLElement{
  constructor() {
    super();
    this.overlayElement = Utility.DomSelector.byId('site-overlay');
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   */
  onClick(){
    SiteOverlay.hideOverlay();
  }

  /**
   * Show Overlay
   * @param {string} drawerClass - Optional class to add based on drawer type
   * @returns {boolean} Returns true if overlay was shown, false if already visible
   */
   static showOverlay(drawerClass = null){
    const overlay = Utility.DomSelector.byId('site-overlay');
    if (overlay.classList.contains('overlay--body')) {
      return false; // Already visible
    }
    
    Utility.CSS.add(overlay, 'overlay--body');
    overlay.setAttribute('aria-hidden', 'true');
    Utility.CSS.add(document.body, 'scroll-fixed');
    
    // Add drawer-specific class if provided
    if (drawerClass) {
      Utility.CSS.add(overlay, drawerClass);
    }
    
    // Make background content inert (prevents focus and interaction)
    // const mainContent = Utility.DomSelector.$('main');
    // const header = Utility.DomSelector.$('header');
    // if (mainContent) mainContent.setAttribute('inert', '');
    // if (header) header.setAttribute('inert', '');
    
    return true; // Successfully shown
  }

  /**
   * Hide overlay
   * @returns {boolean} Returns true if overlay was hidden, false if already hidden
   */
  static hideOverlay(){
    const overlay = Utility.DomSelector.byId('site-overlay');
    if (!overlay.classList.contains('overlay--body')) {
      return false; // Already hidden
    }
    
    const openDrawers = Utility.DomSelector.$$('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
    
    // Remove all drawer-specific overlay classes (keep only overlay--body and scroll-fixed)
    const overlayClasses = Array.from(overlay.classList).filter(cls => cls !== 'overlay--body' && cls !== 'scroll-fixed');
    overlayClasses.forEach(cls => Utility.CSS.remove(overlay, cls));
    
    Utility.CSS.remove(overlay, 'overlay--body');
    Utility.CSS.remove(document.body, 'scroll-fixed');
    
    // Remove inert from background content
    // const mainContent = Utility.DomSelector.$('main');
    // const header = Utility.DomSelector.$('header');
    // if (mainContent) mainContent.removeAttribute('inert');
    // if (header) header.removeAttribute('inert');
    
    return true; // Successfully hidden
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick.bind(this));
    this.removeEventListener('touchend', this.onClick.bind(this));
  }
}
customElements.define("site-overlay", SiteOverlay, {
  once: true
});

/**
* Custom Video
*/
class CustomVideo extends HTMLElement {
  constructor() {
    super();

    this.type = this.dataset.videoType;
    this.videoURL = this.dataset.videoId;
    this.placementType = this.dataset.placement;
    this.videoStatus = 'empty';
    
    this.container = this.closest('.custom-video-container');
    this.videoModal = document.getElementById('PopupModal-video');
    this.contentSection = Utility.DomSelector.$('.content-section', this);
    this.videoSection = Utility.DomSelector.$('.video-section', this);
    if(this.placementType == 'popup') this.videoSection = Utility.DomSelector.$('.video-container', this.videoModal);
    this.triggerVideo = Utility.DomSelector.$('[data-trigger-video]', this) || Utility.DomSelector.$('[data-trigger-video]', this.container);

    this.boundToggleView = this.toggleView.bind(this);
  }

  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    if (this.triggerVideo && this.boundToggleView) {
      this.triggerVideo.removeEventListener('click', this.boundToggleView);
    }
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(Utility.DomSelector.exists('[data-poster-video]', this)) this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.boundToggleView);

    // Autoplay on init if placement is grid and autoplay is true and not in a swiper slide. Slider autoplay is managed by the manageSwiperSlides function to support slide init with deferred js loading.
    if(this.dataset.placement == 'grid' && this.dataset.autoplay == 'true' && !this.closest('swiper-slide')) this.autoplayOnInit();
    // if(this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(_event){
    if(this.container.classList.contains('playing--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   * @returns {CustomVideo} Returns this for method chaining
   */
  toggleView(event){
    if(event) event.preventDefault();
    const isOpen = this.container.classList.contains('playing--video');
    if (isOpen) {
      this.hideContent();
    } else {
      this.showContent();
    }
    return this; // Enable method chaining
  }

  /**
   * Show panel content
   * @returns {CustomVideo} Returns this for method chaining
   */
  showContent() {
    if (this.videoStatus === 'empty' || this.placementType === 'popup') {
      const videoElement = this._buildVideo();
      if (!videoElement) {
        console.error('Failed to build video element');
        return this;
      }
      
      videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);
      
      if (!this.videoSection) {
        console.error('Video section not found');
        return this;
      }
      
      this.videoSection.appendChild(videoElement);
      this.videoStatus = 'loaded';

      setTimeout(() => {
        (this.placementType === 'popup') ? openModal(this.videoModal, this.triggerVideo) : Utility.CSS.add(this.container, 'playing--video');
        this.videoSection.removeAttribute('inert');
        this.videoSection.setAttribute('aria-hidden', 'false');
        if(this.dataset.controls === 'true') this.pauseOnVisibilityChange(videoElement);
      }, 500);
    } else {
      const videoElement = Utility.DomSelector.$('.video-section video', this) || Utility.DomSelector.$('.video-section iframe', this);
      if (videoElement) {
        Utility.CSS.add(this.container, 'playing--video');
        this._playVideo(videoElement);
      }
    }
    return this; // Enable method chaining
  }

  /**
   * Hide panel content
   * @returns {CustomVideo} Returns this for method chaining
   */
  hideContent() {
    Utility.CSS.remove(this.container, 'playing--video');
    this.videoSection.setAttribute('inert', '');
    this.videoSection.setAttribute('aria-hidden', 'true');
    const videoElement = Utility.DomSelector.$('.video-section video', this) || Utility.DomSelector.$('.video-section iframe', this);
    if (videoElement) {
      this._pauseVideo(videoElement);
    }
    return this; // Enable method chaining
  }

  _playVideo(video){
    if (!video) return;

    try {
      if(this.type === 'local'){
        video.play().catch(err => console.warn('Video autoplay blocked:', err));
      } else if(this.type === 'youtube'){
        video.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', 'https://www.youtube.com');
      }
    } catch (err) {
      console.error('Play video error:', err);
    }
  }

  _pauseVideo(video) {
    if (!video) return;
    
    try {
      if (this.type === 'local') {
        video.pause();
      } else if (this.type === 'youtube') {
        video.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', 'https://www.youtube.com');
      }
    } catch (err) {
      console.error('Pause video error:', err);
    }
  }

  /**
   * Create the video html element
   */
  _buildVideo(){
    try {
      if (!this.videoURL) {
        console.error('Video URL is missing');
        return null;
      }

      const hasControls = this.dataset.controls === 'true';
      const isMuted = this.dataset.muted === 'true';
      const isLoop = this.dataset.loop === 'true';

      if(this.type === 'local'){
        const video = document.createElement('video');
        video.src = this.videoURL;
        video.autoplay = true;
        video.playsInline = true;
        if(hasControls) video.controls = true;
        if(isMuted) video.muted = true;
        if(isLoop) video.loop = true;
        return video;
      }

      if(this.type === 'youtube'){
        let videoID = (this.videoURL || '').trim();
        if (videoID.includes('youtube.com/watch') || videoID.includes('youtu.be/')) {
          try {
            const u = new URL(videoID.startsWith('http') ? videoID : `https://${videoID}`);
            if (u.hostname.includes('youtu.be')) {
              videoID = u.pathname.replace(/^\//, '').split('/')[0] || '';
            } else {
              videoID = u.searchParams.get('v') || '';
            }
          } catch (_) {
            videoID = videoID.replace(/^https?:\/\/www\.youtube\.com\/watch\?v=/i, '').split('&')[0];
          }
        } else {
          videoID = videoID.replace(/^https?:\/\/www\.youtube\.com\/watch\?v=/i, '').split('&')[0].split('#')[0];
        }
        if (!videoID) {
          console.error('Invalid YouTube URL');
          return null;
        }
        const video = document.createElement("iframe");
        video.setAttribute("allowfullscreen", "");
        video.setAttribute("frameborder", "0");
        video.setAttribute("allow", "autoplay");
        video.setAttribute("src", `https://www.youtube.com/embed/${videoID}?rel=0&showinfo=0&autoplay=1&mute=${isMuted ? 1 : 0}&controls=${hasControls ? 1 : 0}&loop=${isLoop ? 1 : 0}&enablejsapi=1&origin=${window.origin}`);
        return video;
      }

      return null;
    } catch (err) {
      console.error('Video build error:', err);
      return null;
    }
  }

  /**
   * Pause video on scroll when out of viewport
   */
  pauseOnVisibilityChange(videoEle){
    if (!videoEle) return;
    
    this.scrollObserver = Utility.Observer.onChange(
      videoEle,
      null,  // onEnter - no action needed
      (video) => {  // onExit - pause video
        if(!video || video.contentWindow == null){
          this.scrollObserver?.disconnect();
          return;
        }
        this._pauseVideo(video);
      }
    );
  }

  /**
   * Poster Video Autoplay
   */
  managePosterVideos(){
    const posterVideo = Utility.DomSelector.$('[data-poster-video]', this);
    if(!posterVideo) return;

    Utility.Observer.once(posterVideo, (video) => {
      try {
        if (!video.dataset.src) return;
        const sourceTag = document.createElement('source');
        sourceTag.src = video.dataset.src;
        sourceTag.type = "video/mp4";
        video.appendChild(sourceTag);
        video.play().catch(err => console.warn('Poster video autoplay blocked:', err));
      } catch (err) {
        console.error('Poster video error:', err);
      }
    });
  }

  autoplayOnInit(element = this){
    Utility.Observer.once(element, (el, entry) => {
      if(entry.intersectionRatio > 0){
        el.toggleView();
      }
    });
  }
}
customElements.define("custom-video", CustomVideo);

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;
    this.modal = Utility.DomSelector.$('.modal', this);
    this.modalOpeners = Utility.DomSelector.$$(`[data-modal-opener="${this.id}"]`);
    this.closeBtn = Utility.DomSelector.$('[id^="ModalClose-"]', this);

    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');
  }

  connectedCallback() {
    this.modalOpeners.forEach((opener)=>{
      opener.addEventListener('click', (evt)=>{
        evt.preventDefault();
        this.show(opener);
      });
    });

    if (this.closeBtn) {
      this._boundHide = this.hide.bind(this);
      this.closeBtn.addEventListener('click', this._boundHide);
    }

    this._boundBackdropClick = (evt) => {
      if (!this.isOpen) return;
      const panel = evt.target.closest('.modal-dialog');
      if (!panel || !this.contains(panel)) {
        this.hide();
      }
    };
    this.addEventListener('click', this._boundBackdropClick);

    this._boundModalKeyUp = (evt) => {
      if (evt.code && evt.code.toUpperCase() === 'ESCAPE') this.hide();
    };
    this.addEventListener('keyup', this._boundModalKeyUp);
  }

  // Clean up event listeners
  disconnectedCallback() {
    this.isOpen = false;

    this.modalOpeners.forEach((opener) => {
      opener.removeEventListener('click', this.show.bind(this));
    });

    if (this.closeBtn && this._boundHide) {
      this.closeBtn.removeEventListener('click', this._boundHide);
    }

    if (this._boundBackdropClick) {
      this.removeEventListener('click', this._boundBackdropClick);
    }
    if (this._boundModalKeyUp) {
      this.removeEventListener('keyup', this._boundModalKeyUp);
    }
  }

  /**
   * Open the Modal
   * @param {element} opener 
   * @returns {ModalDialog} Returns this for method chaining
   */
  show(opener) {
    if (this.isOpen) return this; // Prevent opening if already open

    this.isOpen = true;
    this.openedBy = opener;
    Utility.CSS.add(this.modal, 'open');
    this.removeAttribute('inert');
    this.setAttribute('aria-hidden', 'false');

    SiteOverlay.showOverlay();
    
    // Announce modal opening with specific name
    const modalName = this.getAttribute('aria-label') || 'Modal Dialogue';
    Utility.announceToScreenReader(`${modalName} modal opened`);
    
    Utility.Focus.trap(this, this.closeBtn);
    
    return this; // Enable method chaining
  }

  /**
   * Close Modal Dialogue
   * @returns {ModalDialog} Returns this for method chaining
   */
  hide() {
    if (!this.isOpen) return this; // Prevent closing if already closed

    this.isOpen = false;
    Utility.CSS.remove(this.modal, 'open');
    this.setAttribute('inert', '');
    this.setAttribute('aria-hidden', 'true');

    SiteOverlay.hideOverlay();
    
    // Announce modal closing with specific name
    const modalName = this.getAttribute('aria-label') || 'Modal Dialogue';
    Utility.announceToScreenReader(`${modalName} modal closed`);
    
    Utility.Focus.release(this.openedBy);
    if(this.id == 'PopupModal-video') {
      Utility.DomSelector.$('.video-container', this).innerHTML = '';
    }
    
    return this; // Enable method chaining
  }
}
customElements.define('modal-dialog', ModalDialog);

class CustomDrawer extends HTMLElement {
  constructor() {
      super();
      this.isOpen = false;

      this.openedBy = null;
      this.toggleDrawer = [];
      this._boundToggleClick = null;
    this._boundDelegatedCloseClick = null;
    this._boundKeyUp = null;
      this._eventsBound = false;
      this.setAttribute('aria-hidden', 'true');
      this.setAttribute('inert', '');
  }

  connectedCallback() {
    this.unbindEvents();
    const drawerId = this.getAttribute('id') || this.id;
    if (drawerId) {
      this.toggleDrawer = Utility.DomSelector.$$(`[data-toggleDrawer="${drawerId}"], a[href="#${drawerId}"]`);
    }
    this.forceFocus = Utility.DomSelector.$('.first-focusable-ele', this) || Utility.DomSelector.$('.drawer-header', this);
    this.bindEvents();
  }

  disconnectedCallback() {
    this.unbindEvents();
  }

  unbindEvents() {
    if (this._boundToggleClick && this.toggleDrawer?.length) {
      this.toggleDrawer.forEach((btn) => btn.removeEventListener('click', this._boundToggleClick));
    }
    if (this._boundDelegatedCloseClick) {
      this.removeEventListener('click', this._boundDelegatedCloseClick);
    }
    if (this._boundKeyUp) {
      this.removeEventListener('keyup', this._boundKeyUp);
    }
    this._eventsBound = false;
  }

  bindEvents(){
    if (this._eventsBound) return;
    this._eventsBound = true;

    this._boundToggleClick = (evt) => {
      evt.preventDefault();
      (this.isOpen) ? this.closeDrawer(evt) : this.openDrawer(evt.currentTarget);
    };
    this.toggleDrawer.forEach((btn) => {
      btn.setAttribute('aria-expanded', false);
      btn.addEventListener('click', this._boundToggleClick);
    });

    this._boundDelegatedCloseClick = (evt) => {
      const closeTrigger = evt.target.closest('[data-closedrawer]');
      if (!closeTrigger || !this.contains(closeTrigger)) return;
      evt.preventDefault();
      this.closeDrawer();
    };
    this.addEventListener('click', this._boundDelegatedCloseClick);

    this._boundKeyUp = this.onKeyUp.bind(this);
    this.addEventListener('keyup', this._boundKeyUp);
  }

  /**
   * Escape Key Press to close drawer when focus is within the container
   */
  onKeyUp(event) {
    if (event.code?.toUpperCase() !== 'ESCAPE') return;
    this.closeDrawer();
  }

  openDrawer(opener) {
    // Prevent opening if already open
    if (this.isOpen) return this;

    this.resetOtherDrawers();

    this.isOpen = true;
    this.openedBy = opener || null;
    Utility.CSS.add(this, 'open');
    this.removeAttribute('inert');
    this.setAttribute('aria-hidden', 'false');

    // Create drawer-specific overlay class from drawer ID
    const drawerClass = this.id || null;
    SiteOverlay.showOverlay(drawerClass);
    
    // Add below-header class to overlay if drawer has it
    const overlay = Utility.DomSelector.byId('site-overlay');
    if (overlay && this.classList.contains('below-header')) {
      Utility.CSS.add(overlay, 'below-header');
    }
    
    this.openedBy?.setAttribute('aria-expanded', true);
    Utility.Focus.trap(this, this.forceFocus);
    
    // Announce drawer opening to screen readers
    const drawerName = this.getAttribute('aria-label') || 'Drawer';
    Utility.announceToScreenReader(`${drawerName} drawer opened`);
    
    return this; // Enable method chaining
  }

  closeDrawer() {
      if (!this.isOpen) return this;

      Utility.CSS.remove(this, 'open');
      
      // Remove drawer-specific overlay class and below-header class
      const overlay = Utility.DomSelector.byId('site-overlay');
      if (overlay && this.id) {
        Utility.CSS.remove(overlay, this.id);
        Utility.CSS.remove(overlay, 'below-header');
      }
      
      SiteOverlay.hideOverlay();

      this.isOpen = false;
      this.setAttribute('inert', '');
      this.setAttribute('aria-hidden', 'true');
      this.hideOpenPanels();
      this.openedBy?.setAttribute('aria-expanded', false);
      Utility.Focus.release(this.openedBy);
      
      // Announce drawer closing to screen readers
      const drawerName = this.getAttribute('aria-label') || 'Drawer';
      Utility.announceToScreenReader(`${drawerName} drawer closed`);
      
      if(this.id == 'quickshop-drawer') {
        Utility.DomSelector.$('[data-quickshop-body]', this).innerHTML = '';
      } else if (this.id == 'recipe-drawer') {
        const recipeBody = Utility.DomSelector.$('[data-recipe-drawer-body]', this);
        if (recipeBody) recipeBody.innerHTML = '';
      } else if(this.id == 'header-search-layer') {
        const searchInput = this.querySelector('input[name="q"]');
        if(searchInput) {
          searchInput.value = '';
          searchInput.dispatchEvent(new Event('input'));
        }
      }
      this.openedBy = null;
      
      return this; // Enable method chaining
  }

  resetOtherDrawers(){
    const openDrawers = Utility.DomSelector.$$('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
    return this; // Enable method chaining
  }

  hideOpenPanels(){
    let openPanels = this.querySelectorAll('[is="collapsiblePanel"].open');
    openPanels.forEach(panel => panel.querySelector('[data-toggle="panel"]').click());

    let openDropdowns = Array.from(this.querySelectorAll('[is="drop-down"].open'));
    openDropdowns.forEach((ele) => {
      Utility.CSS.remove(ele, 'open');
      Utility.DomSelector.$('[data-toggle="open"]', ele)?.setAttribute('aria-expanded', false);
    });
    return this; // Enable method chaining
  }
}
customElements.define('custom-drawer', CustomDrawer);

/**
   * Manage Custom Notification Trigger
   *
   */
class ToastNotification extends HTMLElement {
  constructor() {
    super();

    this.container = Utility.DomSelector.$('.snotifyToast', this);
    this.closeBtn = Utility.DomSelector.$('.snotifyToast__close', this);
    this.animateNotifcation = null;

    // Set ARIA role for accessibility
    this.container.setAttribute('role', 'alert');
    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');
  }

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
      });
    }
  }

  disconnectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }
  }

  /**
   * Notification Type
   * @param {string} title 
   * @param {string} body 
   * @param {object} options 
   * @returns {ToastNotification} Returns this for method chaining
   */
  updateNotification(title, body, options){
    this.setAttribute('aria-hidden', 'false');
    this.removeAttribute('inert');

    Utility.CSS.add(this.container, 'open', `snotify-${options.type}`);
    Utility.DomSelector.$('.snotifyToast__title', this).textContent = title;
    Utility.DomSelector.$('.snotifyToast__body', this).textContent = body;

    this._manageToggle(options.timeout);
    
    return this; // Enable method chaining
  }

  /**
   * Duration of notification to hide again
   * @param timeout 
   */
  _manageToggle(timeout) {
    this.progressBar = Utility.DomSelector.$('[data-toast-pr]', this);
    const totalFrames = Math.ceil(timeout / 16.67) / 2;
    let frame =0; 
    let width = 0;

    this.animateNotifcation = () => {
      width = (frame / totalFrames) * 100;
      this.progressBar.setAttribute('style', `width: ${width}%`);
      if (frame < totalFrames) {
        frame++;
        requestAnimationFrame(this.animateNotifcation);
      } else {
        this.closeBtn.dispatchEvent(new Event('click'));
      }
    };
    requestAnimationFrame(this.animateNotifcation);
  }

  /**
   * Hide notification
   * @returns {ToastNotification} Returns this for method chaining
   */
  hide() {
    if (this.animateNotification) {
      cancelAnimationFrame(this.animateNotification);
    }
    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');

    this.container.className = 'snotifyToast';
    [Utility.DomSelector.$('.snotifyToast__title', this),Utility.DomSelector.$('.snotifyToast__body', this)].forEach(ele => ele.textContent = '');
    Utility.DomSelector.$("[data-toast-pr]", this).removeAttribute("style");

    return this; // Enable method chaining
  }
}
customElements.define("toast-notification", ToastNotification);
window.notificationEle = Utility.DomSelector.$('toast-notification');

//===============================================================================================================
//          Video Management Functions for Custom Video in Swiper Slides                                        //
//===============================================================================================================

/**
 * Handle slide video play/pause on slide change
 * @param {HTMLElement} slide 
 * @param {boolean} shouldPlay 
 */
const handleSlideVideo = (slide, shouldPlay) => {
  if (!slide) return;

  const videoHost = Utility.DomSelector.$('custom-video', slide);
  if (!videoHost) return;

  const media = Utility.DomSelector.$('video', videoHost) || Utility.DomSelector.$('iframe', videoHost);
  if (videoHost.videoStatus == 'loaded' && !media) return;

  try {
    if (shouldPlay) {
      if (videoHost.videoStatus === 'empty') {
        videoHost.toggleView();
      } else {
        videoHost._playVideo(media);
      }
    } else if (videoHost.dataset.controls === 'true') {
      videoHost._pauseVideo(media);
    }
  } catch (err) {
    console.error('Swiper slide video control error:', err);
  }
};

/**
 * Run autoplay on first active slide if autoplay is true and placement is grid
 * @param {HTMLElement} swiperEl 
 */
const runAutoplayIfActive = (swiperEl) => {
  if(!swiperEl || !swiperEl.querySelector('custom-video')) return;

  const firstActiveSlide = Utility.DomSelector.$('swiper-slide', swiperEl);
  if(!firstActiveSlide) return;

  const customVideo = firstActiveSlide.querySelector('custom-video');
  if(!customVideo) return;

  if(customVideo.dataset.autoplay === 'true' && customVideo.dataset.placement === 'grid') customVideo.autoplayOnInit(customVideo);
};

/**
 * Swiper sets aria-controls to an internal shadow-DOM wrapper id and aria-disabled="false"
 * when enabled — both fail accessibility audits. Re-sync whenever Swiper mutates nav buttons.
 */
const SWIPER_NAV_SELECTOR = '.swiper-button-prev, .swiper-button-next';
const observedSwiperNavButtons = new WeakSet();

const ensureSwiperContainerId = (swiperEl) => {
  if (!swiperEl.id) {
    const section = swiperEl.closest('[id^="shopify-section-"], [id^="shopify-block-"]');
    const nearest = swiperEl.closest('section[id], div[id]');
    const basis = section?.id || nearest?.id;
    swiperEl.id = basis
      ? `swiper-${String(basis).replace(/^shopify-section-/, '').replace(/^shopify-block-/, '')}`
      : `swiper-${Math.random().toString(36).slice(2, 11)}`;
  }
  return swiperEl.id;
};

const syncSwiperNavButtonA11y = (btn) => {
  if (!(btn instanceof HTMLButtonElement)) return;

  if (btn.type !== 'button') btn.type = 'button';

  const a11yStrings = globalThis.accessibilityStrings || {};
  if (btn.classList.contains('swiper-button-prev')) {
    btn.setAttribute('aria-label', btn.getAttribute('aria-label') || a11yStrings.previousSlide || 'Slide left');
  } else if (btn.classList.contains('swiper-button-next')) {
    btn.setAttribute('aria-label', btn.getAttribute('aria-label') || a11yStrings.nextSlide || 'Slide right');
  }

  // Swiper sets aria-controls to internal wrapper ids that are not in the document.
  // aria-label is sufficient for carousel navigation; drop aria-controls to pass audits.
  if (btn.hasAttribute('aria-controls')) {
    btn.removeAttribute('aria-controls');
  }

  const disabled = btn.classList.contains('swiper-button-disabled');
  const ariaDisabled = btn.getAttribute('aria-disabled');
  if (disabled) {
    if (ariaDisabled !== 'true') btn.setAttribute('aria-disabled', 'true');
  } else if (ariaDisabled !== null) {
    btn.removeAttribute('aria-disabled');
  }
};

const observeSwiperNavButton = (btn) => {
  syncSwiperNavButtonA11y(btn);
  if (observedSwiperNavButtons.has(btn)) return;
  observedSwiperNavButtons.add(btn);

  const observer = new MutationObserver(() => syncSwiperNavButtonA11y(btn));
  observer.observe(btn, {
    attributes: true,
    attributeFilter: ['class', 'aria-disabled', 'aria-controls'],
  });
};

const fixAllSwiperNavigationA11y = () => {
  document.querySelectorAll(SWIPER_NAV_SELECTOR).forEach(observeSwiperNavButton);
};

const scheduleSwiperNavA11ySync = () => {
  fixAllSwiperNavigationA11y();
  requestAnimationFrame(fixAllSwiperNavigationA11y);
  window.setTimeout(fixAllSwiperNavigationA11y, 0);
  window.setTimeout(fixAllSwiperNavigationA11y, 100);
};

globalThis.fixAllSwiperNavigationA11y = fixAllSwiperNavigationA11y;
globalThis.scheduleSwiperNavA11ySync = scheduleSwiperNavA11ySync;

const fixSwiperNavigationA11y = (swiperEl) => {
  if (!swiperEl) return;
  ensureSwiperContainerId(swiperEl);
  const navRoot = swiperEl.closest('.swiper-wrapper__custom') || swiperEl.parentElement;
  navRoot?.querySelectorAll(SWIPER_NAV_SELECTOR).forEach(observeSwiperNavButton);
};

const syncProductThumbAria = (swiperEl) => {
  if (!swiperEl?.classList?.contains('product-image-thumbs')) return;

  swiperEl.querySelectorAll('swiper-slide').forEach((slide) => {
    const thumb = slide.querySelector('.product-thumb--image');
    if (!thumb) return;
    thumb.setAttribute(
      'aria-current',
      slide.classList.contains('swiper-slide-thumb-active') ? 'true' : 'false'
    );
  });
};

const boundSwiperElements = new WeakSet();

/**
 * Manage Swiper slide video control
 * @param {HTMLElement} swiperEl 
 */
const bindSwiperElement = (swiperEl) => {
  if (!swiperEl || boundSwiperElements.has(swiperEl)) return;
  boundSwiperElements.add(swiperEl);

  swiperEl.addEventListener(
    'swiper:init',
    () => {
      runAutoplayIfActive(swiperEl);
      fixSwiperNavigationA11y(swiperEl);
      syncProductThumbAria(swiperEl);
      requestAnimationFrame(() => {
        fixSwiperNavigationA11y(swiperEl);
        syncProductThumbAria(swiperEl);
        scheduleSwiperNavA11ySync();
      });
    },
    { once: true }
  );

  ['swiperupdate', 'swiperslidechange', 'swipernavigationhide', 'swipernavigationshow'].forEach((eventName) => {
    swiperEl.addEventListener(eventName, () => {
      fixSwiperNavigationA11y(swiperEl);
      syncProductThumbAria(swiperEl);
    });
  });

  swiperEl.addEventListener('swiperslidechange', ({ detail }) => {
    const swiperInstance = detail && detail[0];
    if (!swiperInstance) return;

    const { activeIndex, previousIndex, slides } = swiperInstance;
    if (!slides || activeIndex == null || previousIndex == null) return;

    const prevSlide = slides[previousIndex];
    const activeSlide = slides[activeIndex];

    handleSlideVideo(prevSlide, false);
    handleSlideVideo(activeSlide, true);
  });

  if (swiperEl.swiper) {
    runAutoplayIfActive(swiperEl);
    fixSwiperNavigationA11y(swiperEl);
    syncProductThumbAria(swiperEl);
  }
};

/**
 * @returns {void}
 */
const manageSwiperSlides = () => {
  const swiperSliders = Utility.DomSelector.$$('swiper-container');
  if (!swiperSliders.length) return;

  swiperSliders.forEach(bindSwiperElement);
};
manageSwiperSlides();
document.addEventListener('shopify:section:load', () => {
  manageSwiperSlides();
  scheduleSwiperNavA11ySync();
});
scheduleSwiperNavA11ySync();
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleSwiperNavA11ySync, { once: true });
}

customElements.whenDefined('swiper-container').then(() => {
  scheduleSwiperNavA11ySync();
  manageSwiperSlides();
});

//===============================================================================================================
//          End of Video Management Functions for Custom Video and Swiper Slide Components                      //
//===============================================================================================================


//===============================================================================================================
//  --pe-product-card-height / --product-media-height — product cards only; .card-product-promo is ignored     //
//===============================================================================================================

(() => {
  const NAV_SELECTOR = '.custom-swiper-navigation';
  const TAB_TOGGLE_SELECTOR = '[data-toggle="tab"]';
  const TAB_PANEL_SELECTOR = '[data-tabpanel]';
  const TAB_CONTENT_CLASS = 'tabcontent';
  const DELAY = 50;
  const RESIZE_DELAY = 100;
  const PRODUCT_CARD_SELECTOR = '.card-product:not(.card-product-promo)';
  const COLLECTION_GRID_SELECTOR = '.product-list__grid';

  /**
   * Group grid items that share the same visual row (handles promo col-span).
   * @param {Element[]} elements
   * @param {number} tolerancePx
   * @returns {Element[][]}
   */
  const rowTopKey = (el) => Math.round(el.getBoundingClientRect().top);

  const groupGridRowsByTop = (elements, tolerancePx = 8) => {
    if (!elements.length) return [];
    const sorted = [...elements].sort((a, b) => {
      const ta = rowTopKey(a);
      const tb = rowTopKey(b);
      if (Math.abs(ta - tb) > tolerancePx) return ta - tb;
      return a.getBoundingClientRect().left - b.getBoundingClientRect().left;
    });
    const rows = [];
    for (let i = 0; i < sorted.length; i++) {
      const el = sorted[i];
      const top = rowTopKey(el);
      let row = rows.find((r) => Math.abs(r.top - top) <= tolerancePx);
      if (!row) {
        row = { top, items: [] };
        rows.push(row);
      }
      row.items.push(el);
    }
    return rows.map((r) => r.items);
  };

  let collectionGridResizeObserver;
  const observeCollectionGrids = () => {
    if (typeof ResizeObserver === 'undefined') return;
    if (!collectionGridResizeObserver) {
      collectionGridResizeObserver = new ResizeObserver(() => {
        scheduleUpdate(DELAY);
      });
    }
    document.querySelectorAll(COLLECTION_GRID_SELECTOR).forEach((grid) => {
      if (grid.dataset.peGridHeightObserve === '1') return;
      grid.dataset.peGridHeightObserve = '1';
      collectionGridResizeObserver.observe(grid);
    });
  };

  const applyCollectionGridHeights = (grid) => {
    const visibleChildren = [...grid.children].filter((el) => el.offsetParent !== null);
    if (!visibleChildren.length) {
      grid.style.removeProperty('--pe-product-card-height');
      return;
    }

    const clearRowVar = (el) => el.style.removeProperty('--pe-product-card-height');

    const productCardsInGrid = [...grid.querySelectorAll(PRODUCT_CARD_SELECTOR)].filter(
      (c) => c.offsetParent !== null
    );
    const productHeightsAll = productCardsInGrid.map((c) => c.offsetHeight).filter((h) => h > 0);
    const gridProductMax = productHeightsAll.length ? Math.max(...productHeightsAll) : 0;

    const rows = groupGridRowsByTop(visibleChildren);
    for (let r = 0; r < rows.length; r++) {
      const row = rows[r];
      const productOnlyHeights = row
        .filter((el) => el.matches(PRODUCT_CARD_SELECTOR))
        .map((el) => el.offsetHeight)
        .filter((h) => h > 0);
      let rowMax = productOnlyHeights.length ? Math.max(...productOnlyHeights) : 0;
      if (rowMax === 0 && gridProductMax > 0) {
        rowMax = gridProductMax;
      }
      for (let i = 0; i < row.length; i++) {
        const el = row[i];
        if (rowMax > 0) {
          el.style.setProperty('--pe-product-card-height', `${rowMax}px`);
        } else {
          clearRowVar(el);
        }
      }
    }
    grid.style.removeProperty('--pe-product-card-height');
  };

  const updateHeights = () => {
    observeCollectionGrids();
    document.querySelectorAll(COLLECTION_GRID_SELECTOR).forEach(applyCollectionGridHeights);

    const cards = document.querySelectorAll(PRODUCT_CARD_SELECTOR);
    const updates = [];
    for (let i = 0; i < cards.length; i++) {
      const card = cards[i];
      if (!card || card.offsetParent === null) continue;

      const media = card.querySelector('.product--media');
      if (!media) continue;

      const nav = card.closest('.swiper-wrapper__custom, section, .slider-wrapper')?.querySelector(NAV_SELECTOR);
      const inCollectionGrid = Boolean(card.closest(COLLECTION_GRID_SELECTOR));

      updates.push({
        card,
        mediaHeight: media.offsetHeight,
        cardHeight: card.offsetHeight,
        nav,
        inCollectionGrid
      });
    }

    for (let i = 0; i < updates.length; i++) {
      const { card, mediaHeight, cardHeight, nav, inCollectionGrid } = updates[i];

      if (!inCollectionGrid) {
        card.style.setProperty('--pe-product-card-height', `${cardHeight}px`);
      }
      card.style.setProperty('--product-media-height', `${mediaHeight}px`);

      if (nav) {
        nav.style.setProperty('--product-media-height', `${mediaHeight}px`);
        nav.style.setProperty('--nav-opacity', '1');
        nav.classList.add('arrow-center-image');
      }
    }
  };

  const scheduleUpdate = (delay = 0) => window.setTimeout(updateHeights, delay);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeights, { once: true });
  } else {
    updateHeights();
  }

  window.addEventListener('load', updateHeights);

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(updateHeights, RESIZE_DELAY);
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest(TAB_TOGGLE_SELECTOR)) scheduleUpdate(DELAY);
  });

  const observer = new MutationObserver((mutations) => {
    const shouldUpdate = mutations.some(({ target, attributeName }) => (
      ['aria-hidden', 'class'].includes(attributeName) &&
      target.classList?.contains(TAB_CONTENT_CLASS) &&
      target.classList.contains('open') &&
      target.getAttribute('aria-hidden') === 'false'
    ));

    if (shouldUpdate) scheduleUpdate(DELAY);
  });

  document.querySelectorAll(TAB_PANEL_SELECTOR).forEach((panel) => {
    observer.observe(panel, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });
  });
})();

//===============================================================================================================
//          End of Update Product Media Height Functions for Product Cards                                        //
//===============================================================================================================

// Dropdown outside-click handler → moved to dropdown.js

//===============================================================================================================
//          Mute videos when browser tab is hidden (Page Visibility API)                                      //
//===============================================================================================================

(function setupMuteVideosOnDocumentHidden() {
  const YT_IFRAME_SELECTOR =
    'iframe[src*="youtube.com/embed"], iframe[src*="youtube-nocookie.com/embed"]';

  function muteYoutubeIframe(iframe) {
    try {
      iframe?.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'mute', args: '' }), '*');
    } catch (_) {}
  }

  function syncSoundButtonForSlideMedia(mediaEl) {
    const slide = mediaEl.closest('swiper-slide');
    slide?.querySelector('.custom-video-sound-button')?.classList.remove('sound-on');
  }

  function onVisibilityChange() {
    if (!document.hidden) return;

    document.querySelectorAll('video').forEach((video) => {
      try {
        if (video.paused || video.ended) return;
        video.muted = true;
        syncSoundButtonForSlideMedia(video);
      } catch (_) {}
    });

    document.querySelectorAll(YT_IFRAME_SELECTOR).forEach((iframe) => {
      muteYoutubeIframe(iframe);
      syncSoundButtonForSlideMedia(iframe);
    });
  }

  document.addEventListener('visibilitychange', onVisibilityChange);
})();

//===============================================================================================================
//          Header and Announcement Bar Height Calculator                                                       //
//===============================================================================================================


function setHeaderTopbarCSSVars() {
  const root = document.documentElement;
  const header = document.querySelector('.section-header');
  const topbar = document.querySelector('.topbar');
  const consultantUtilityBar = document.querySelector('.consultant-utility-bar');
  
  if (consultantUtilityBar) {
    const consultantUtilityBarHeight = consultantUtilityBar.offsetHeight;
    root.style.setProperty('--consultant-utility-bar-height', consultantUtilityBarHeight + 'px');
  }
  if (header) {
    const headerHeight = header.offsetHeight;
    root.style.setProperty('--header-height', headerHeight + 'px');
  }
  if (topbar) {
    const topbarHeight = topbar.offsetHeight;
    root.style.setProperty('--announcement-bar-height', topbarHeight + 'px');
  }
}
setHeaderTopbarCSSVars();
window.addEventListener('resize', setHeaderTopbarCSSVars);


//===============================================================================================================
//          End of Header and Announcement Bar Height Calculator                                               //
//===============================================================================================================

//===============================================================================================================
//          Article / recipe RTE: strip inline styles, classes, and empty noise                               //
//===============================================================================================================

/**
 * @param {Element} container — root `.article-content` or `.recipe-drawer-content`
 */
function watkinsStripRteBloat(container) {
  if (!container || !(container instanceof Element)) return;

  container.querySelectorAll('*').forEach((el) => {
    el.removeAttribute('style');
    // el.removeAttribute('class');
  });

  const emptyNodes = [];
  container.querySelectorAll('*').forEach((el) => {
    const content = el.innerHTML
      .replace(/<br\s*\/?>/gi, '')
      .replace(/&nbsp;|\u00A0/gi, '')
      .trim();
    if (content === '') emptyNodes.push(el);
  });
  emptyNodes.forEach((el) => el.remove());

  container.querySelectorAll('span, p').forEach((el) => {
    const inner = el.innerHTML
      .replace(/<br\s*\/?>/gi, '')
      .replace(/&nbsp;/gi, '')
      .replace(/\u00A0/g, '')
      .trim();
    if (inner === '') el.style.display = 'none';
  });
}

function watkinsInitArticleRteCleaning() {
  document.querySelectorAll('.article-content, .recipe-drawer-content').forEach((root) => {
    watkinsStripRteBloat(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', watkinsInitArticleRteCleaning, { once: true });
} else {
  watkinsInitArticleRteCleaning();
}

window.watkinsStripRteBloat = watkinsStripRteBloat;

//===============================================================================================================
//          End of Article / recipe RTE cleaning                                                               //
//===============================================================================================================